import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchParam } from '@constants/common';
import { logError } from '@utils/errors';

export const useSearchParam = (paramName: SearchParam) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get(paramName) || undefined;

  const deleteParamFromUrl = useCallback(() => {
    if (!param) {
      return;
    }

    searchParams.delete(paramName);

    // `setSearchParams` ends up in `history.replaceState`, which react-router
    // calls without a guard and whose promise it drops on the floor — a throw
    // there would only ever show up as an unowned rejection.
    try {
      setSearchParams(searchParams, { replace: true });
    } catch (error) {
      logError(error, { location: 'useSearchParam.deleteParamFromUrl' });
    }
  }, [param, paramName, searchParams, setSearchParams]);

  return {
    param,
    deleteParamFromUrl,
  };
};
